<template>
  <div class="col-md-12">
    <br />
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Serial Number :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            v-validate="'required'"
            name="SerialNo"
            v-model="encodingData.SerialNo"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('SerialNo') }"
          />
        </div>
        <div
          v-if="submitted && errors.has('SerialNo')"
          class="invalid-feedback"
        >
          {{ errors.first("SerialNo") }}
        </div>
      </div>
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Make :</label
        >
        <div class="col-md-6 col-sm-6">
          <input name="Make" v-model="encodingData.Make" class="form-control" />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Caliber :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Caliber"
            v-model="encodingData.Caliber"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Model :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Model"
            v-model="encodingData.Model"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            rows="5"
            cols="5"
            class="form-control"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopFA" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  checkLinkMode,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        SerialNo: "",
        Make: "",
        Caliber: "",
        Model: "",
        Comments: "",
      },
      submitted: false,
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          instance
            .post(EncodeURL + "newfirearms", this.encodingData, {
              headers: authHeader(),
            })
            .then((response) => {
              loader.hide();
              if (response.data.error) {
                notifyHelper(
                  "error",
                  "There was an error processing your request!"
                );
              } else {
                notifyHelper("success", "Saved");
                loader.hide();
                //this.clearControls()
                if (checkLinkMode()) {
                  if (confirm("Link this newly created entity?")) {
                    setObject2Link(response.data.id, "FA");
                    this.setLink(response.data.id);
                  }
                }
              }
            })
            .catch(function (error) {
              loader.hide();
              responseCheck(error.response.status);
            });
        }
      });
    },
    setLink: function (id) {
      setObject2Link(id, "FA");
      this.$bvModal.show("LinkPopFA");
    },
    clearControls() {
      this.encodingData.SerialNo = "";
      this.encodingData.Make = "";
      this.encodingData.Caliber = "";
      this.encodingData.Model = "";
      this.encodingData.Comments = "";
    },
  },
};
</script>

